"use strict";
/**
 * @file Created on 05.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NThresholdSystemVolume_1 = require("../model/NThresholdSystemVolume");

var NThresholdSystemVolumeConverter_1 = require("./NThresholdSystemVolumeConverter");
/**
 * @author Tomas Leity
 */


var NThresholdSystemVolumeConverterImpl =
/*#__PURE__*/
function (_NThresholdSystemVolu) {
  _inherits(NThresholdSystemVolumeConverterImpl, _NThresholdSystemVolu);

  function NThresholdSystemVolumeConverterImpl() {
    _classCallCheck(this, NThresholdSystemVolumeConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(NThresholdSystemVolumeConverterImpl).apply(this, arguments));
  }

  _createClass(NThresholdSystemVolumeConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new NThresholdSystemVolume_1.NThresholdSystemVolume(NThresholdSystemVolume_1.NThresholdSystemVolume.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NThresholdSystemVolume_1.NThresholdSystemVolume.schema.productName.valueOf(source.productName), NThresholdSystemVolume_1.NThresholdSystemVolume.schema.productExternalId.valueOf(source.productExternalId), NThresholdSystemVolume_1.NThresholdSystemVolume.schema.systemVolume.valueOf(conversions.toBigNumber(source.systemVolume)), NThresholdSystemVolume_1.NThresholdSystemVolume.schema.systemVolumeOld.valueOf(conversions.toBigNumber(source.systemVolumeOld)), NThresholdSystemVolume_1.NThresholdSystemVolume.schema.systemVolumeAbsDiff.valueOf(conversions.toBigNumber(source.systemVolumeAbsDiff)), NThresholdSystemVolume_1.NThresholdSystemVolume.schema.systemVolumeRelDiff.valueOf(conversions.toBigNumber(source.systemVolumeRelDiff)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        productExternalId: source.productExternalId,
        systemVolume: conversions.fromBigNumber(source.systemVolume),
        systemVolumeOld: conversions.fromBigNumber(source.systemVolumeOld),
        systemVolumeAbsDiff: conversions.fromBigNumber(source.systemVolumeAbsDiff),
        systemVolumeRelDiff: conversions.fromBigNumber(source.systemVolumeRelDiff)
      });
      return result;
    }
  }]);

  return NThresholdSystemVolumeConverterImpl;
}(NThresholdSystemVolumeConverter_1.NThresholdSystemVolumeConverter);

exports.NThresholdSystemVolumeConverterImpl = NThresholdSystemVolumeConverterImpl;
/**
 * IOC Container qualifier
 */

NThresholdSystemVolumeConverterImpl.QUALIFIER = {
  documentType: NThresholdSystemVolume_1.NThresholdSystemVolume.name
};